import React from "react";
import { TableWrapper } from "./Styles";

const Table = (props) => {
  return <TableWrapper>{props.children}</TableWrapper>;
};

export default Table;
